import type { PresignedUploadDto, UploadPurpose } from '@posilka/shared';
import { compressImage } from '../lib/image';
import { api } from './client';

/** Siqadi → presign → S3'ga to'g'ridan-to'g'ri POST (XHR — progress uchun). Key qaytaradi. */
export async function uploadImage(
  file: File,
  purpose: UploadPurpose,
  onProgress?: (ratio: number) => void,
): Promise<string> {
  const blob = await compressImage(file);
  const contentType = blob.type as 'image/webp' | 'image/jpeg';
  const presigned = await api<PresignedUploadDto>('/uploads/presign', {
    method: 'POST',
    body: { purpose, contentType },
  });
  if (blob.size > presigned.maxBytes) throw new Error('FILE_TOO_LARGE');

  const form = new FormData();
  for (const [k, v] of Object.entries(presigned.fields)) form.append(k, v);
  form.append('file', blob);

  await new Promise<void>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', presigned.url);
    xhr.upload.onprogress = (e) => e.lengthComputable && onProgress?.(e.loaded / e.total);
    xhr.onload = () =>
      xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`UPLOAD_${xhr.status}`));
    xhr.onerror = () => reject(new Error('UPLOAD_NETWORK'));
    xhr.send(form);
  });
  onProgress?.(1);
  return presigned.key;
}
